import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
import { LatexRenderer } from '../../ui/LatexRenderer';
import { Card } from '../../ui/Card';
interface AnswerComparisonProps {
  userAnswer: string;
  correctAnswer: string;
  isCorrect: boolean;
  mode?: 'full' | 'compact';
}
/**
 * Displays user's answer compared to the correct answer
 * Used in both PracticeSession (immediate feedback) and CitoSimulator (review)
 */
export function AnswerComparison({
  userAnswer,
  correctAnswer,
  isCorrect,
  mode = 'full'
}: AnswerComparisonProps) {
  if (mode === 'compact') {
    // Compact mode for review lists
    return <div className="grid gap-3" data-id="element-569">
        <div className={`p-3 rounded-lg border-2 ${isCorrect ? 'border-emerald-300 bg-emerald-50' : 'border-rose-300 bg-rose-50'}`} data-id="element-570">
          <div className="text-xs font-bold uppercase mb-1 text-slate-600" data-id="element-571">
            Jouw antwoord
          </div>
          <div className="font-medium text-slate-900" data-id="element-572">
            <LatexRenderer content={userAnswer} data-id="element-573" />
          </div>
        </div>

        {!isCorrect && <div className="p-3 rounded-lg border-2 border-emerald-300 bg-emerald-50" data-id="element-574">
            <div className="text-xs font-bold uppercase mb-1 text-emerald-700" data-id="element-575">
              Goede antwoord
            </div>
            <div className="font-medium text-emerald-900" data-id="element-576">
              <LatexRenderer content={correctAnswer} data-id="element-577" />
            </div>
          </div>}
      </div>;
  }
  // Full mode for immediate feedback
  return <>
      {/* User's answer */}
      <motion.div initial={{
      opacity: 0,
      x: -10
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.1
    }} data-id="element-578">
        <div className="bg-white rounded-xl p-4 border-2 border-rose-100 inline-flex items-center gap-3 shadow-sm" data-id="element-579">
          <span className="text-xs font-bold uppercase tracking-wider text-rose-400" data-id="element-580">
            Jouw antwoord:
          </span>
          <span className="font-bold text-rose-700 text-lg" data-id="element-581">
            <LatexRenderer content={userAnswer} data-id="element-582" />
          </span>
          <XCircle className="w-5 h-5 text-rose-500" data-id="element-583" />
        </div>
      </motion.div>

      {/* Correct answer (only show when wrong) */}
      {!isCorrect && <motion.div initial={{
      opacity: 0,
      x: 10
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.2
    }} data-id="element-584">
          <div className="bg-white rounded-xl p-4 border-2 border-emerald-100 inline-flex items-center gap-3 shadow-sm" data-id="element-585">
            <span className="text-xs font-bold uppercase tracking-wider text-emerald-400" data-id="element-586">
              Het juiste antwoord:
            </span>
            <span className="font-bold text-emerald-700 text-lg" data-id="element-587">
              <LatexRenderer content={correctAnswer} data-id="element-588" />
            </span>
            <CheckCircle className="w-5 h-5 text-emerald-500" data-id="element-589" />
          </div>
        </motion.div>}
    </>;
}